import JSX from "../../helpers/react.js";
import TextInput from "../elements/TextInput.js";
import {ISelectValue, Select} from "../elements/Select.js";
import {EditTextBox, initTinyMceEditor} from "../textbox/EditTextBox.js";
import {showNotice} from "../../helpers/functions.js";
import RefObject = JSX.RefObject;

async function submitData(e: SubmitEvent, postId?: number){
    e.preventDefault();
    await new Promise(r => setTimeout(r));

    const categoryId = $('select[name=category_id]').val(),
        title=$('input[name=article_title]').val(),
        content = ($('.comment-textarea').val() as string).trim();
    try {
        /**@var { {error?: string; post_id: number}} response*/
        const body = JSON.stringify({
            title: title,
            content: content,
            category_id: categoryId,
        });

        const response = await fetch(!postId?'/posts/create/add-post.php':`/posts/${postId}`, {
            method: postId?'PUT':'POST',
            body
        })
            .then(e => e.json());
        if(response.error) throw response.error;
        location.href = `/posts/${response.post_id}`;
    }
    catch (e){
        showNotice(e+'', 'Ошибка', 'error');
        console.error(e);
    }

}
export function AddPostForm({text, title, category_id, postId}: {text?: string, title?: string, category_id?: number, postId?: number}){
    if(![1,2,3].includes(+category_id!)) category_id = 1;
    const select: RefObject<HTMLSelectElement> = {};
    const el = (
        <form className="content-page" id="add-post-form" onSubmit={e=>submitData(e, postId)}>
            <h2>Опубликовать пост</h2>
            <TextInput value={title} name="article_title" placeholder="Название" style={{marginBottom: '5px'}} />
            <Select name="category_id" placeholder="" multiple={false} onChange={()=> {}} ref={select}>
                {
                    ...[
                        {name: 'Новости сайта', value: '1', selected: category_id == 1},
                        {name: 'Новости аниме', value: '2', selected: category_id == 2},
                        {name: 'Статьи', value: '3', selected: category_id == 3},
                    ] as ISelectValue[]
                }
            </Select>
            <div className="flex add-post-content post-text">
                <textarea className="comment-textarea" name="post_box" id="tiny_mce_editor"></textarea>
                {/*<EditTextBox name="post_box" title="Статья" />*/}
                {/*<EditBoxMenuBtns>*/}
                    <input type="submit" id="add-post" className="main-button bordered" value="Опубликовать" style={{marginTop: '10px'}}/>
                {/*</EditBoxMenuBtns>*/}
            </div>
        </form>
    );
    $(select.value!).slimSelect();


    setTimeout(()=>
        initTinyMceEditor("Статья", text || (localStorage['text_post_box']??''), e=>void (localStorage['text_post_box']=e)),
        0
    );

    return el;
}



$(function (){
    let createPost = document.getElementById('create-post');
    if(createPost)
        createPost.appendChild(<AddPostForm />);
    createPost = document.getElementById('edit-post');
    if(createPost)
        createPost.appendChild(
            <AddPostForm
                text={createPost.dataset.text} title={createPost.dataset.title}
                category_id={+createPost.dataset.categoryId!}
                postId={+createPost.dataset.postId!}
            />
        );

});


